<template>
    <p><b>A partir de quando você quer começar a controlar as tarefas?</b></p>
    <div class="column is-6">
      <TrfInput
        type="date"
        id="data-primeiro-acesso"
        v-model="dataInicioTarefasWeb"
        ref="inputDataPrimeiroAcesso"
      />
    </div>
    <p>
      <b>Observação:</b> Vou salvar essa data no cadastro das empresas e ela será usada para criar todo o controle de tarefas.
    </p>
</template>

<script>
import TrfInput from "../Input/index.vue";

export default {
  name: "TrfWizardModuloDataDeInicio",
  components: {
    TrfInput,
  },
  props: {
    valorInicial: {
      type: [String, null],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      dataInicioTarefasWeb: this.valorInicial,
      isDataValida: false
    };
  },
  methods: {
    validar() {
      this.isDataValida = !this.$refs.inputDataPrimeiroAcesso.verificarSeInputDoTipoDateEstaVazio() &&
          this.$refs.inputDataPrimeiroAcesso.verificarSeDataEValida()
      this.$emit('update:isDataValida', this.isDataValida);
      return this.isDataValida
    },
  },
  watch: {
    dataInicioTarefasWeb: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        this.dataInicioTarefasWeb = novo;
        this.$emit('update:dataInicioTarefasWeb', this.dataInicioTarefasWeb);
      },
    },
  },
  updated() {
    this.validar();
  }
};
</script>

<style lang="scss" scoped>
.column.is-6 {
  padding: 0;
}
</style>